$( "#product_accordion" ).accordion({
  collapsible: true,
  heightStyle: "content",
  active: false
});
function resetTabs() {
  $('.tab-btns .btn').click(function(){
    $('.tab-btns .btn').removeClass('active');
    $(this).addClass('active');
    $('.post-wrapper').removeClass('active');
    if ($(this).hasClass('speakers-btn') ) {
      $('.speakers').addClass('active');
    } else {
      $('.headphones').addClass('active');
    }
  });
}
resetTabs();

function overlayMobile () {
  var overlay = $('.desktop-text-wrap'),
      active = 'active',
      mobileWrap = $('.mobile-text-wrap');
  if (!mobileWrap.hasClass(active)) {
    var overlayContent = overlay.html();
    mobileWrap.html(overlayContent);
    overlay.empty();
    overlay.removeClass(active);
    mobileWrap.addClass(active);
    resetTabs();
  }
}
function overlayMobileUndo () {
  var overlay = $('.desktop-text-wrap'),
      active = 'active',
      mobileWrap = $('.mobile-text-wrap');
  if (mobileWrap.hasClass(active)) {
    var overlayContent = mobileWrap.html();
    overlay.html(overlayContent);
    mobileWrap.empty();
    mobileWrap.removeClass(active);
    overlay.addClass(active);
    resetTabs();
  }
}

var win	= $(window),
    document = $(document);

if ( win.width() >= 768 ) {
}
else {
  overlayMobile();
}
win.resize(function() {
  if ( win.width() >= 768 ) {
    overlayMobileUndo();
  }
  else {
    overlayMobile();
  }
});